import { FieldPossibleValue } from '@sb-tools/typescript/models/field-possible-value.model';
import { FieldType } from '@sb-tools/typescript/enums/field-type.enum';

export class FieldBase {
    id: number;
    name: string;
    possibleValues: FieldPossibleValue[];
    type: FieldType;
}
